import React from 'react'
import {
  Button,
  Container,
  FieldText,
  Icon,
  Tools
} from '@pdrj/pmi-iqos-ds-react'
import SpotsMapDetailPopup from './spots-map-detail-popup'
import SpotsFilters from './spots-filters'

const SpotsFiltersTop = ({
  translations,
  filters,
  handleChangeSearchInput,
  handleClearSearchInput,
  searchInputValue,
  toggleFilterHandler,
  spot,
  usageTypes,
  onCloseHandler,
  showDetailPopup,
  fullDetail,
  setFullDetail,
  handleSearchLocation,
  searchedLocation
}) => {
  return (
    <Container
      px={['0', '8', '16']}
      fullWidth
      display={Container.displays.flex}
      flexDirection={[
        Container.flexDirections.column,
        Container.flexDirections.row
      ]}
      justifyContent={Container.justifyContentValues.center}>
      <Container
        form
        px={['8', '', '']}
        width={['full', '1/3', '1/3']}
        position={Container.positions.relative}>
        <Container>
          <FieldText
            name={'search-filter-input'}
            label={translations.tk_inputLocation}
            fullWidth
            value={searchInputValue}
            onChangeHandler={handleChangeSearchInput}
            icon={searchInputValue ? Icon.images.cancel : Icon.images.search}
            onIconClickHandler={
              searchInputValue ? handleClearSearchInput : handleSearchLocation
            }
            roundedInput={true}
            showState={false}
            data-testing="SpotsFiltersTop_FieldText_Search"
          />
          <Container display={Container.displays.none}>
            <Button onClickHandler={handleSearchLocation} />
          </Container>
        </Container>

        {Tools.isDesktop() && showDetailPopup ? (
          <Container
            position={Container.positions.absolute}
            l="0"
            r="0"
            t="16"
            pt="2"
            data-testing="SpotsFiltersTop_Container_DetailPopup">
            <SpotsMapDetailPopup
              spot={spot}
              usageTypes={usageTypes}
              onCloseHandler={onCloseHandler}
              translations={translations}
              fullDetail={fullDetail}
              setFullDetail={setFullDetail}
            />
          </Container>
        ) : null}
      </Container>
      <Container width={['full', '2/3', '2/3']}>
        <Container
          pl="1"
          pb="4"
          display={Container.displays.flex}
          overflow={!Tools.isDesktop()}
          flexWrap={Tools.isDesktop()}>
          <SpotsFilters
            filters={filters}
            toggleFilterHandler={toggleFilterHandler}
          />
        </Container>
      </Container>
    </Container>
  )
}

export default SpotsFiltersTop
